// extracted by mini-css-extract-plugin
export default {"resumeSection":"resume_resumeSection__WVuy0","resumeLink":"resume_resumeLink__sFK2-"};